import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
} from '../../components/Form';


import {
    Title,
    PanelBox,
    Paragraph,
} from '../../components/Display';
import { postData } from '../../Api';

export default function MembershipTransactionTypesDelete(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const handlecomp1 = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handlecomp2 = async () => {
        await postData('/api/panel/page/membership-transaction-types-delete/save-data', {
            id: allProps['membership-transaction-types-id'],
        });
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    useEffect(() => {
        postData('/api/panel/page/membership-transaction-types-delete/form-data', {
            id: allProps['membership-transaction-types-id'],
        }).then((response) => {});
    }, []);
    return (
        <PanelBox>
            <Title>عنوان صفحه</Title>
            <DataForm>
                <Title>هشدار</Title>
                <Paragraph>رکورد حذف شود؟</Paragraph>
                <LeftComponents>
                    <Button onClick={handlecomp1}>انصراف</Button>
                    <Button onClick={handlecomp2}>حذف</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
